"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UploadAllowedInterceptor", {
    enumerable: true,
    get: function() {
        return UploadAllowedInterceptor;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _catchError = require("~/helpers/catchError");
const _globals = require("~/utils/globals");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let UploadAllowedInterceptor = class UploadAllowedInterceptor {
    async intercept(context, next) {
        var _request_user;
        const request = context.switchToHttp().getRequest();
        if (!((_request_user = request['user']) == null ? void 0 : _request_user.id)) {
            var _request_user1;
            if (!((_request_user1 = request['user']) == null ? void 0 : _request_user1.isPublicBase)) {
                _catchError.NcError.unauthorized('Unauthorized');
            }
        }
        try {
            if ((0, _nocodbsdk.extractRolesObj)(request['user'].roles)[_nocodbsdk.OrgUserRoles.SUPER_ADMIN] || (0, _nocodbsdk.extractRolesObj)(request['user'].roles)[_nocodbsdk.OrgUserRoles.CREATOR] || (0, _nocodbsdk.extractRolesObj)(request['user'].roles)[_nocodbsdk.ProjectRoles.EDITOR] || !!await _Noco.default.ncMeta.knex(_globals.MetaTable.PROJECT_USERS).where(function() {
                this.where('roles', _nocodbsdk.ProjectRoles.OWNER);
                this.orWhere('roles', _nocodbsdk.ProjectRoles.CREATOR);
                this.orWhere('roles', _nocodbsdk.ProjectRoles.EDITOR);
            }).andWhere('fk_user_id', request['user'].id).first()) {
                return next.handle();
            }
        } catch (unused) {}
        _catchError.NcError.badRequest('Upload not allowed');
    }
};
UploadAllowedInterceptor = _ts_decorate([
    (0, _common.Injectable)()
], UploadAllowedInterceptor);
